import React from 'react';
import classNames from 'classnames';
import { useChatSidebar } from './GlobalChatSidebar/ChatSidebarProvider';
import DisasterChatManager from './DisasterGPT/DisasterChatManager';
import { StylishNewButton } from './DesignSystems/New/StylishNewButton';
import { SharedIcon } from './SharedIcon/SharedIcon';
import './GlobalChatSidebar.scss';

const GlobalChatSidebar: React.FC = () => {
  const { isVisible, hide } = useChatSidebar();

  const sidebarClasses = classNames('global-chat-sidebar', {
    'global-chat-sidebar--visible': isVisible,
    'global-chat-sidebar--hidden': !isVisible,
  });

  return (
    <div className={sidebarClasses}>
      <div className="sidebar-content-wide d-flex flex-column h-100">
        <div className="sidebar-title">
          <h4 className="m-0">PRATUS AI Chat</h4>
          <StylishNewButton
            customButton
            className="button--icon"
            onClick={hide}
          >
            <SharedIcon iconName="close" />
          </StylishNewButton>
        </div>
        <div className="sidebar-content-wrapper">
          <DisasterChatManager selectedDatetime={new Date().toISOString()} />
        </div>
      </div>
    </div>
  );
};

export default GlobalChatSidebar;
